module.exports = __webpack_public_path__ + "img/pannel.3d500b49.jpg";